import {
  AmendPaymentChangeAmountRequestActionEnum,
  AmendPaymentWaiveRequestActionEnum,
} from "@/api/model";

/**
 * Combined enum mirroring the two `action` literals from the polymorphic
 * `AmendPaymentRequest` API contract. Derived from generated enums so it stays
 * in sync with the OpenAPI spec without hand-typing values.
 */
export const ActionEnum = {
  ...AmendPaymentChangeAmountRequestActionEnum,
  ...AmendPaymentWaiveRequestActionEnum,
} as const;

export type ActionEnum = (typeof ActionEnum)[keyof typeof ActionEnum];
